import React from 'react';
import { Helmet } from 'react-helmet';

/**
 * SEO组件 - 为每个页面提供元数据和社交媒体标签
 * @param {Object} props
 * @param {string} props.title - 页面标题
 * @param {string} props.description - 页面描述
 * @param {string} props.keywords - SEO关键词，逗号分隔
 * @param {string} props.canonicalUrl - 规范URL，默认为当前URL
 * @param {string} props.ogImage - 社交媒体分享图片URL
 * @param {string} props.ogType - Open Graph类型，默认为website
 * @param {string} props.twitterCard - Twitter卡片类型，默认为summary_large_image
 */
const SEO = ({
  title = '图美啦 - 专业在线图片美化工具',
  description = '图美啦是一款专业的在线图片美化工具，支持一键为截图添加精美背景和标注，让您的图片展示效果更专业。',
  keywords = '图片美化,截图美化,图片编辑器,在线图片工具,图片标注,图片裁剪',
  canonicalUrl = typeof window !== 'undefined' ? window.location.href : 'https://snapbeautify.toolooz.com/',
  ogImage = 'https://snapbeautify.toolooz.com/og-image.png',
  ogType = 'website',
  twitterCard = 'summary_large_image',
}) => {
  // 基本URL
  const baseUrl = 'https://snapbeautify.toolooz.com';
  
  // 完整的图片URL
  const fullImageUrl = ogImage.startsWith('http') ? ogImage : `${baseUrl}${ogImage}`;
  
  // 完整的规范URL
  const fullCanonicalUrl = canonicalUrl.startsWith('http') ? canonicalUrl : `${baseUrl}${canonicalUrl}`;
  
  return (
    <Helmet>
      {/* 基本元数据 */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* 规范链接 */}
      <link rel="canonical" href={fullCanonicalUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={fullCanonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImageUrl} />
      
      {/* Twitter */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:url" content={fullCanonicalUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImageUrl} />
    </Helmet>
  );
};

export default SEO; 